import { render, staticRenderFns } from "./ListSoftwaresWarningSection.vue?vue&type=template&id=06d1585c&scoped=true&"
import script from "./ListSoftwaresWarningSection.vue?vue&type=script&lang=js&"
export * from "./ListSoftwaresWarningSection.vue?vue&type=script&lang=js&"
import style0 from "./ListSoftwaresWarningSection.vue?vue&type=style&index=0&id=06d1585c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d1585c",
  null
  
)

export default component.exports